import ApiClient from './ApiClient';

class SocialCommentsAPI extends ApiClient {
  constructor() {
    super('social_comments', { accountScoped: true });
  }

  getComments({ platform = 'all', filter = 'all' } = {}) {
    return axios.get(this.url, { params: { platform, filter } });
  }

  replyToComment({ commentId, message, platform }) {
    return axios.post(`${this.url}/reply`, {
      comment_id: commentId,
      message,
      platform,
    });
  }

  startConversation({ commenterId, commenterName, platform, commentText }) {
    return axios.post(`${this.url}/start_conversation`, {
      commenter_id: commenterId,
      commenter_name: commenterName,
      platform,
      comment_text: commentText,
    });
  }
}

export default new SocialCommentsAPI();
